<div class="quickflows-section" style="padding-bottom: 10px">
    <div class="quickflows-section-header">
        <ycn-icon-search-autocomplete
                [appendToBody]="true"
                [searchType]="'quickflow_securities'"
                (submitHandler)="addItem($event)">
        </ycn-icon-search-autocomplete>
        <div class="feedback">Compare 2 to 12 securities.</div>
    </div>
    <div class="quickflows-labels-list" *ngIf="items.length">
        <div class="btn btn-purple-tint"
             data-test-id="quickflows-comparison-security"
             *ngFor="let item of items | slice:0:12; index as index">
            <div
                    ycnTooltip
                    [tooltipPlacement]="'left'"
                    [tooltipTitle]="item.securityName">
                <a href="{{ item.securityUrl }}">
                    {{ item.displaySecurityId }}
                </a>
            </div>
            <div class="btn btn-xs btn-circle btn-transparent btn-close" (click)="deleteItem(index)">
                <span><svg ycnIcon [name]="'icon-close-circle'"></svg></span>
            </div>
        </div>
    </div>

    <button *ngIf="items.length > 1 && hasSmartCompareFeature"
            class="btn btn-outline btn-secondary"
            style="width: 100%"
            data-test-id="quickflows-smart-compare-button"
            (click)="handleSmartCompareClick()">
        Smart Compare
        <svg ycnIcon [name]="'icon-sparkle'" style="margin-left: 4px; margin-bottom: 4px;"></svg>
    </button>
</div>
<div class="quickflows-section" *ngIf="items.length < 2 && !loadingCollection">
    <div class="get-started-small">
        <span>Add at least 2 securities</span>
        <span>to view Quickflow Comparisons</span>
    </div>
</div>
<div class="quickflows-section"
     *ngIf="items.length >= 2 && availableQuickflows.length == 0 && !loadingCollection">
    <div class="get-started-small">
        <span>There are no quickflows available for</span>
        <span>the current assortment of securities</span>
    </div>
</div>
<ng-container *ngIf="items.length >= 2 && !loadingCollection">
    <div class="quickflows-section"
         *ngFor="let quickflows_grouped_by_app of availableQuickflows">
        <div class="quickflows-section-title" [textContent]="quickflows_grouped_by_app['app_name']"></div>
        <div class="quickflows-list">
            <div *ngFor="let quickflow of quickflows_grouped_by_app['quickflows']">
                <a class="quickflows-list-item" href="javascript:void(0)">
                    <span (click)="select(quickflow['id'])" [textContent]="quickflow['label']"></span>
                    <div class="btn btn-xs btn-circle btn-transparent btn-i"
                         *ngIf="quickflow['tooltip_text']"
                         ycnTooltip
                         [tooltipClasses]="['popover']"
                         [tooltipTitle]="quickflow['tooltip_text']">
                        <svg ycnIcon [name]="'icon-info'"></svg>
                    </div>
                </a>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="loadingCollection">
    <div class="quickflows-section"
         *ngFor="let quickflow of availableQuickflows">
        <div class="quickflows-list options-list-skeleton">
            <div class="skeleton" style="width: 88%;"></div>
            <div class="skeleton" style="width: 40%;"></div>
            <div class="skeleton" style="width: 15%;"></div>
            <div class="skeleton" style="width: 65%;"></div>
        </div>
    </div>
</ng-container>
